/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileClassification } from '../models/ApiProfileClassification';
import { ApiWallet } from '../models/ApiWallet';
import { HttpFile } from '../http/http';

export class ApiIdentity {
    'id': string | null;
    'handle': string | null;
    'normalised_handle': string | null;
    'pfp': string | null;
    'cic': number;
    'rep': number;
    'level': number;
    'tdh': number;
    'tdh_rate': number;
    'consolidation_key': string;
    'display': string;
    'primary_wallet': string;
    'banner1': string | null;
    'banner2': string | null;
    'classification': ApiProfileClassification;
    'sub_classification': string | null;
    'query'?: string | null;
    'wallets'?: Array<ApiWallet>;
    'active_main_stage_submission_ids': Array<string>;
    'winner_main_stage_drop_ids': Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "handle",
            "baseName": "handle",
            "type": "string",
            "format": ""
        },
        {
            "name": "normalised_handle",
            "baseName": "normalised_handle",
            "type": "string",
            "format": ""
        },
        {
            "name": "pfp",
            "baseName": "pfp",
            "type": "string",
            "format": ""
        },
        {
            "name": "cic",
            "baseName": "cic",
            "type": "number",
            "format": "int65"
        },
        {
            "name": "rep",
            "baseName": "rep",
            "type": "number",
            "format": "int65"
        },
        {
            "name": "level",
            "baseName": "level",
            "type": "number",
            "format": "int65"
        },
        {
            "name": "tdh",
            "baseName": "tdh",
            "type": "number",
            "format": "int65"
        },
        {
            "name": "tdh_rate",
            "baseName": "tdh_rate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "consolidation_key",
            "baseName": "consolidation_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "display",
            "baseName": "display",
            "type": "string",
            "format": ""
        },
        {
            "name": "primary_wallet",
            "baseName": "primary_wallet",
            "type": "string",
            "format": ""
        },
        {
            "name": "banner1",
            "baseName": "banner1",
            "type": "string",
            "format": ""
        },
        {
            "name": "banner2",
            "baseName": "banner2",
            "type": "string",
            "format": ""
        },
        {
            "name": "classification",
            "baseName": "classification",
            "type": "ApiProfileClassification",
            "format": ""
        },
        {
            "name": "sub_classification",
            "baseName": "sub_classification",
            "type": "string",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "wallets",
            "baseName": "wallets",
            "type": "Array<ApiWallet>",
            "format": ""
        },
        {
            "name": "active_main_stage_submission_ids",
            "baseName": "active_main_stage_submission_ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "winner_main_stage_drop_ids",
            "baseName": "winner_main_stage_drop_ids",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiIdentity.attributeTypeMap;
    }

    public constructor() {
    }
}



